import { Component } from '@angular/core';
import { NotificationComponent } from '../modules/notification/notification.component';

@Component({
  selector: 'ava-notification-custom-element',
  template: ` <ava-notification /> `,
  standalone: true,
  imports: [NotificationComponent],
})
export class NotificationCustomElementComponent {}
